export default __webpack_public_path__ + "static/carriaged-house-door-30ed563cabf3523d789e1b004a7fc5fb.svg";